<template>
  <BasicModalWindow
    ref="modal_element"
    class="small-window folders-empty"
    :title="modal_title"
    :gtm="{
      module : 'folders',
      feature: 'folders_empty_modal',
      block  : 'modal_header',
      action : 'cancel'
    }"
  >
      <template #body>
          <h3>
            {{Language.say('folders.empty.confirmation', [selected_folder.name])}}
          </h3>
          <p v-if="selected_folder.id === SAPOMailConfig.client.folders.alias.trash || selected_folder.id === SAPOMailConfig.client.folders.alias.spam">
            {{Language.say('folders.empty.delete_permanent')}}
            <br>
            {{Language.say('folders.empty.non_reversable')}}
          </p>
          <p v-else>
            {{Language.say('folders.empty.messages_to_trash')}}
          </p>
      </template>

      <template #footer>
          <ActionButton
              @click="onClose()"
              text="folders.empty.cancel"
              :gtm="{
                module : 'folders',
                feature: 'folders_empty_modal',
                block  : 'modal_footer',
                action : 'cancel'
              }"
          />
          <ActionButton
              @click="onEmptyFolder()"
              class='main-action push-right'
              text="folders.empty.confirm"
              :loading="folders_controller.saving_state.saving[selected_folder.id]"
              :gtm="{
                module : 'folders',
                feature: 'folders_empty_modal',
                block  : 'modal_footer',
                action : 'submit'
              }"
          />
      </template>
  </BasicModalWindow>
</template>

<script setup>
  import { defineProps, ref } from 'vue';
  import BasicModalWindow     from '@/vue/Layouts/Modals/BasicModalWindow.vue';
  import ActionButton         from '@/vue/Elements/Buttons/ActionButton.vue'
  import Language             from '@/js/Shared/Language/Language.js';
  import FoldersController    from '@/js/Mailboxes/FoldersController';
  import SAPOMailConfig       from '@/SAPOMailConfig';

  const props   = defineProps({
    selected_folder : {
      required: true,
    }
  })

  const modal_element      = ref();
  const modal_title        = Language.say('folders.empty.title', [props.selected_folder.name]);
  const folders_controller = FoldersController;

  const onEmptyFolder = async () => {
    folders_controller.empty(props.selected_folder);
    close();
  }

  const onClose = async () => {
    close();
  }

  const close = () => {
    modal_element.value.close();
  }
</script>
